import { render, staticRenderFns } from "./NewInstrumentForm.vue?vue&type=template&id=33a9b2ac&scoped=true"
import script from "./NewInstrumentForm.vue?vue&type=script&lang=js"
export * from "./NewInstrumentForm.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=33a9b2ac&prod&scoped=true&lang=css&external"
import style1 from "./NewInstrumentForm.vue?vue&type=style&index=1&id=33a9b2ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9b2ac",
  null
  
)

export default component.exports